import { render, staticRenderFns } from "./ClipMask.vue?vue&type=template&id=95692ac4&scoped=true&"
import script from "./ClipMask.vue?vue&type=script&lang=js&"
export * from "./ClipMask.vue?vue&type=script&lang=js&"
import style0 from "./ClipMask.vue?vue&type=style&index=0&id=95692ac4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95692ac4",
  null
  
)

export default component.exports